export const AbbreviationSKU = [
    {
        id: 1,
        title: "i-t-t",
        content: "آی تی تلکام",
        group: ["brand"],
    },

    // ===== Switches =====
    {
        id: 2,
        title: "sw",
        content: "سوییچ شبکه تجاری",
        sub: "ETH Switch",
        group: ["switch", "layer"],
    },
    {
        id: 3,
        title: "isw",
        content: "سوییچ شبکه صنعتی",
        sub: "ETH Switch",
        group: ["switch", "layer"],
    },
    {
        id: 4,
        title: "iswp",
        content: "سوییچ شبکه صنعتی PoE",
        sub: "ETH Switch",
        group: ["switch", "layer", "poe"],
    },
    {
        id: 5,
        title: "swp",
        content: "سوییچ شبکه PoE",
        sub: "ETH Switch",
        group: ["switch", "layer", "poe"],
    },

    // ===== Fiber =====
    {
        id: 6,
        title: "cor",
        content: "سوییچ فیبر نوری",
        sub: "Core Switch",
        group: ["fiber"],
    },
    {
        id: 7,
        title: "icor",
        content: "سوییچ فیبر نوری صنعتی",
        sub: "Core Switch",
        group: ["fiber"],
    },

    {
        id: 8,
        title: "s",
        content: "پورت فیبر نوری",
        sub: "SFP",
        group: ["fiber-port","number"],
    },
    {
        id: 9,
        title: "sfp",
        content: "پورت فیبر نوری",
        sub: "SFP",
        group: ["fiber-port","number"],
    },
    {
        id: 10,
        title: "xf",
        content: "پورت فیبر نوری",
        sub: "Uplink 10G",
        group: ["fiber-speed","number"],
    },
    {
        id: 11,
        title: "tf",
        content: "پورت فیبر نوری",
        sub: "Uplink 40G",
        group: ["fiber-speed","number"],
    },
    {
        id: 12,
        title: "+",
        sub: "10G",
        content: "ده گیگابیت",
        group: ["fiber-port"],
    },

    // ===== Rack Mount =====
    {
        id: 13,
        title: "irswp",
        content: "رک مونت صنعتی PoE",
        sub: "RackMount",
        group: ["rack", "layer", "poe"],
    },
    {
        id: 14,
        title: "irsw",
        content: "رک مونت صنعتی",
        sub: "RackMount",
        group: ["rack", "layer"],
    },

    // ===== Layer (IMPORTANT RULE) =====
    {
        id: 15,
        title: "l2",
        content: "مدیریتی لایه دو",
        sub: "Managed",
        group: ["layer", "managed"],
    },
    {
        id: 16,
        title: "l3",
        content: "مدیریتی لایه سه",
        sub: "Managed",
        group: ["layer", "managed"],

    },

    // ===== Special =====
    {
        id: 17,
        title: "g",
        sub: "Gigabit ETH",
        content: "پورت اترنت شبکه",
        group: ["number"],
    },
    {
        id: 18,
        title: "ge",
        sub: "Gigabit ETH",
        content: "پورت اترنت شبکه",
        group: ["number"],
    },
    {
        id: 19,
        title: "fe",
        sub: "10/100 ETH ",
        content: "پورت اترنت شبکه 10/100",
        group: ["number"],
    },


    // ===== Media Converter =====
    {
        id: 20,
        title: "mc",
        content: "مدیا کانورتر",
        sub: "Media Converter",
    },
    {
        id: 21,
        title: "sc",
        content: "پورت دو کور",
        sub: "Duplex Fiber (SC)",
    },
    {
        id: 22,
        title: "bd",
        content: "پورت تک کور",
        sub: "Single Fiber (BiDi)",
    },
    {
        id: 23,
        title: "slote1",
        content: "کارت خط ایوان",
        sub: "E1 Line Card",
        group: ["number"],
    },

    {
        id: 24,
        title: "ec",
        content: "ایوان کانورتر",
        sub: "E1 Converter",
    },

    {
        id: 25,
        title: "v",
        content: "کانال صدا",
        sub: "Voice Channel",
        group: ["number"],
    },

    {
        id: 26,
        title: "mu",
        content: "مالتی پلکسر",
        sub: "Multiplexer",
        group: ["number"],
    },

    {
        id: 27,
        title: "pcm",
        content: "مدولاسیون کد پالس",
        sub: "Pulse-code modulation",
    },

    {
        id: 28,
        title: "mpcm",
        content: "مدولاسیون کد مالتی پالس",
        sub: "Multi Pulse-code modulation",
    },


    {
        id: 29,
        title: "m",
        content: "ماژولار",
        sub: "Modular",
    },

    {
        id: 30,
        title: "tdm",
        content: "خط تلفن بر روی شبکه",
        sub: "TDM Over Ip",
    },

    {
        id: 31,
        title: "hdmi",
        content: "پورت HDMI",
        sub: "HDMI Port",
    },

    {
        id: 32,
        title: "1080",
        content: "وضوح کیفیت",
        sub: "Clarity of quality",
    },

    {
        id: 33,
        title: "4K",
        content: "وضوح کیفیت",
        sub: "Clarity of quality",
    },

    {
        id: 34,
        title: "sr",
        content: "مبدل سریال",
        sub: "Serial Converter",
    },

    {
        id: 34,
        title: "rs",
        content: "پورت سریال",
        sub: "RS232/485/422",
    },

    {
        id: 35,
        title: "e1",
        content: "پورت ایوان",
        sub: "E1 Port",
    },

    {
        id: 36,
        title: "pdh",
        content: "دیتا بر روی فیبرنوری",
        sub: "Plesiochronous Digital Hierarchy",
    },
    {
        id: 37,
        title: "wifi",
        content: "انتقال دیتا توسط وای فای",
        sub: "WiFi",
    },
    {
        id: 38,
        title: "sim",
        content: "انتقال دیتا بر بستر 3G/4G",
        sub: "SIM Card",
    },
    {
        id: 39,
        title: "qsfp",
        content: "پورت 100 گیگ فیبرنوری",
        sub: "Q-SFP",
    },

];